import {
    CBadge,
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCardImage,
    CCardText,
    CCardTitle,
    CCol,
    CContainer,
    CDropdown,
    CDropdownDivider,
    CDropdownItem,
    CDropdownMenu,
    CDropdownToggle,
    CFormInput,
    CInputGroup,
    CNav,
    CNavItem,
    CNavLink,
    CRow,
    CSpinner,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CToaster
} from '@coreui/bootstrap-react';
import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import toast from 'react-hot-toast';

import DashboardsService from '../store/dashboards/service';
import Communication from '../communication';
import config from '../config';
import axios from 'axios';
import Analysis from '../utils/analysis';
import Details from '../utils/details';
import Holder from '../utils/holder';
import EarthQuake from '../utils/earthQuake';

function Dashboard() {
    const dispatch = useDispatch();

    const dashboardsData = useSelector((state) => state.dashboardsData);
    const [dashboard, setDashboard] = useState({name: 'اصلی', key: 'main'})
    const [selectedItems, setSelectedItems] = useState([])


    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [hotPairs, setHotPairs] = useState([]);


    useEffect(() => {
        data.length === 0 &&
        fetchData([], 0, 1, "")
    }, []);

    const handelSearchBox = (search) => {
        handelDashboardChanged()
        fetchData([], 0, 1, search)
    }

    const fetchData = async (data, count, page, search) => {
        data.length <= count &&
        await Communication.getMethod(
            config.endPoints.dashboards_tokens + '?id=' + dashboard?.key + "&page=" + page + "&search=" + search)
            .then(result => {
                setPage(page + 1)
                setCount(result.count)
                setData([...data, ...result?.results]);
            }).catch(() => {
            })
            .finally(() => {
            })
    }


    const handelDashboardChanged = () => {
        setData([])
        setCount(0)
        setPage(1)
        return true
    }
    const handelSelecetItem = (objID) => {
        const objInList = selectedItems.find((e) => {
            return e === objID
        })
        let filteredArray = []
        if (objInList !== undefined) {
            filteredArray = selectedItems.filter(item => item !== objID)
        } else {
            filteredArray = [...selectedItems, objID]
        }
        setSelectedItems(filteredArray)
    }

    const clearSelecetedItems = () => (
        setSelectedItems([])
    )

    const validationSelecetedItems = () => {
        if (selectedItems.length > 0) {
            return true
        }
        toast.error('لطفا حداقل یک توکن را انتخاب نمایید.')
        return false
    }

    const handelRemoveItems = () => {
        if (validationSelecetedItems() === true) {
            DashboardsService.makeAction(dispatch, {
                action: 'remove_items',
                dashboard: dashboard.key,
                items: selectedItems
            });
            toast.success('آیتم های انتخاب شده با موفقیت حذف گردید.')
            fetchData([], 0, 1, "")
            clearSelecetedItems()
        }


    }
    const handelRemoveFavoritesItems = () => {
        if (validationSelecetedItems() === true) {
            DashboardsService.makeAction(dispatch, {
                action: 'remove_favorites',
                dashboard: dashboard.key,
                items: selectedItems
            });
            toast.success('آیتم های انتخاب شده با موفقیت از لیست مورد علاقه حذف گردید.')
            fetchData([], 0, 1, "")
            clearSelecetedItems()
        }
    }
    const handelMoveItems = (des_dashboard_key) => {
        if (validationSelecetedItems() === true) {
            DashboardsService.makeAction(dispatch, {
                action: 'move_items',
                dashboard: dashboard.key,
                des_dashboard: des_dashboard_key,
                items: selectedItems
            });
            toast.success('آیتم های انتخاب شده با موفقیت منتقل گردید.')
            fetchData([], 0, 1, "")
            clearSelecetedItems()
        }
    }

    useEffect(() => {
        if (dashboardsData.list | dashboardsData.loading === false) {
            setDashboard(dashboardsData.list.find(obj => {
                return obj.key === dashboard.key;
            }))
            handelDashboardChanged()
            fetchData([], 0, 1, "")
        }

    }, [dashboard])


    return (
        <>
            {(dashboardsData.loading) ? (
                <div className="row justify-content-center ">
                    <CSpinner color="secondary"/>
                </div>
            ) : (
                <CContainer>
                    <CRow>
                        <CCard className="text-center">
                            <CCardHeader>
                                <CNav
                                    variant="pills" className="card-header-pills">
                                    {dashboardsData?.list &&
                                        dashboardsData.list.map((item) => (
                                            <CNavItem>
                                                <CNavLink
                                                    onClick={() => (setDashboard({name: item.name, key: item.key}))}
                                                    active={dashboard.key === item.key ? true : false}>{item?.name}</CNavLink>
                                            </CNavItem>
                                        ))
                                    }
                                </CNav>

                            </CCardHeader>
                            <CCardBody>
                                <CCardTitle>داشبورد {dashboard?.name} (تعداد : {count})</CCardTitle>
                                <CCardText>شما در حال مشاهده لیست توکن های مورد علاقه خود در
                                    داشبورد {dashboard?.name} هستید.</CCardText>
                                <CRow>
                                    <CCol md={4} style={{'textAlign': 'right'}} className="mb-3 mt-3">
                                        <CButtonGroup role="group" aria-label="Button group with nested dropdown">
                                            <CButton color="danger" onClick={clearSelecetedItems}>پاکسازی</CButton>
                                            <CDropdown variant="btn-group" key={1}>
                                                <CDropdownToggle color={'primary'}>عملیات رو موارد انتخاب
                                                    شده</CDropdownToggle>
                                                <CDropdownMenu>
                                                    <CDropdownItem onClick={handelRemoveItems}>حذف موارد انتخاب
                                                        شده</CDropdownItem>
                                                    <CDropdownItem onClick={handelRemoveFavoritesItems}>حذف از لیست
                                                        علاقه مندی</CDropdownItem>
                                                    <CDropdownDivider/>
                                                    {dashboardsData?.list.map((item) => (
                                                        <CDropdownItem onClick={() => (handelMoveItems(item.key))}>انتقال
                                                            به داشبورد {item.name}</CDropdownItem>
                                                    ))}
                                                </CDropdownMenu>
                                            </CDropdown>
                                        </CButtonGroup>
                                    </CCol>
                                    <CCol md={{span: 4, offset: 4}}>
                                        <CInputGroup className="mb-3 mt-3">
                                            <CFormInput placeholder="آدرس توکن مورد نظر خود را وارد نمایید ..."
                                                        aria-label="آدرس توکن مورد نظر خود را وارد نمایید ..."
                                                        aria-describedby="button-addon2"
                                                        onChange={(e) => (handelSearchBox(e.target.value))}/>
                                            <CButton type="button" color="secondary" variant="outline"
                                                     id="button-addon2">جستجو</CButton>
                                        </CInputGroup>
                                    </CCol>
                                </CRow>

                                <CRow xs={{cols: 1, gutter: 4}} md={{cols: 2}}>
                                    {dashboard.key !== 'earthquake' && data?.map((item) => (
                                        <CCol xs>
                                            <CCard style={selectedItems.find((e) => {
                                                return e === item.id
                                            }) && {borderColor: "#ff6c79", background: "#ff6c79"}}>
                                                <div>
                                                    <style
                                                        dangerouslySetInnerHTML={{__html: "#dexscreener-embed{position:relative;width:100%;padding-bottom:125%;}@media(min-width:1400px){#dexscreener-embed{padding-bottom:65%;}}#dexscreener-embed iframe{position:absolute;width:100%;height:100%;top:0;left:0;border:0;}"}}/>
                                                    <div id="dexscreener-embed">
                                                        <iframe
                                                            src={"https://www.geckoterminal.com/" + item.network.key + "/pools/" + item.pair + "?embed=1&info=0&swaps=0"}/>
                                                    </div>
                                                </div>
                                                <CCardBody style={{textAlign: 'right'}}>

                                                    <CCardTitle>{item?.name} | شبکه {item?.network?.name}</CCardTitle>
                                                    <CTable responsive>
                                                        <CTableHead>
                                                            <CTableRow>
                                                                <CTableHeaderCell scope="col">آدرس</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">اونر</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">هلدر</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">مارکت</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">حجم</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">نقدینگی</CTableHeaderCell>
                                                                <CTableHeaderCell scope="col">استخر</CTableHeaderCell>
                                                            </CTableRow>
                                                        </CTableHead>
                                                        <CTableBody>
                                                            <CTableRow>
                                                                <CTableDataCell>

                                                                    <a href={item?.network?.scan_url + item?.address}
                                                                       target='_blank'>
                                                                        {item?.address?.slice(-6)}
                                                                    </a>
                                                                </CTableDataCell>
                                                                <CTableHeaderCell scope="row">
                                                                    <a
                                                                        href={item?.network?.scan_url + item?.owner}
                                                                        target='_blank'>
                                                                        {item?.owner?.slice(-6)}
                                                                    </a>
                                                                </CTableHeaderCell>
                                                                <CTableHeaderCell
                                                                    scope="row">{parseInt(item?.holdersCount).toLocaleString()}</CTableHeaderCell>
                                                                <CTableHeaderCell
                                                                    scope="row">{parseInt(item?.marketcap).toLocaleString()}</CTableHeaderCell>
                                                                <CTableHeaderCell
                                                                    scope="row">{parseInt(item?.value_24h).toLocaleString()}</CTableHeaderCell>
                                                                <CTableHeaderCell
                                                                    scope="row">{parseInt(item?.liquidity).toLocaleString()}</CTableHeaderCell>
                                                                <CTableHeaderCell
                                                                    scope="row">{parseInt(item?.liquidity).toLocaleString()}</CTableHeaderCell>
                                                            </CTableRow>

                                                        </CTableBody>
                                                    </CTable>
                                                    <CCardText>
                                                        <br/>
                                                        {item?.network?.key == 'eth' &&
                                                            <CBadge color="dark" className='m-1'>
                                                                <a href={'https://eth.moonarch.app/token/' + item?.address}
                                                                   style={{color: 'white'}} target='_blank'>Moonarch</a>
                                                            </CBadge>
                                                        }
                                                        <CBadge color="dark" className='m-1'>
                                                            <a href={'https://www.cyberscope.io/cyberscan?network=' + item?.network?.key + '&address=' + item?.address}
                                                               style={{color: 'white'}} target='_blank'>Cyberscope</a>
                                                        </CBadge>
                                                        <CBadge color="dark" className='m-1'>
                                                            <a href={'https://terminal.hapilabs.one/guest-address-check/' + item?.network?.key + '/' + item?.address}
                                                               style={{color: 'white'}} target='_blank'>HAPI LABS</a>
                                                        </CBadge>
                                                        <CBadge color="dark" className='m-1'>
                                                            <a href={'https://www.dexanalyzer.io/token/' + item?.address}
                                                               style={{color: 'white'}} target='_blank'>Dex Analyzer</a>
                                                        </CBadge>

                                                        <CBadge color="dark" className='m-1'>
                                                            <a href={'https://tokensniffer.com/bubble/' + item?.network?.key + '/' + item?.address}
                                                               style={{color: 'white'}} target='_blank'>Token
                                                                Sniffer</a>
                                                        </CBadge>
                                                        <br/>
                                                        <CBadge color="danger" className='m-1'>
                                                            <a href={'https://www.google.com/search?q=' + item?.symbol}
                                                               style={{color: 'white'}} target='_blank'>Google
                                                                search</a>
                                                        </CBadge>
                                                        <CBadge color="primary" className='m-1'>
                                                            <a href={'https://twitter.com/search?q=$' + item?.symbol}
                                                               style={{color: 'white'}} target='_blank'>Twitter
                                                                search</a>
                                                        </CBadge>
                                                        {item?.network?.key == 'eth' ?
                                                            <CBadge color="warning" className='m-1'>
                                                                <a href={'https://www.dextools.io/app/en/ether/pair-explorer/' + item?.pair}
                                                                   style={{color: 'white'}} target='_blank'>DexTools</a>
                                                            </CBadge> :
                                                            <CBadge color="warning" className='m-1'>
                                                                <a href={'https://www.dextools.io/app/en/' + item?.network?.key + '/pair-explorer/' + item?.pair}
                                                                   style={{color: 'white'}} target='_blank'>DexTools</a>
                                                            </CBadge>
                                                        }
                                                    </CCardText>
                                                </CCardBody>
                                                <CCardFooter>
                                                    <small className="text-medium-emphasis">
                                                        رینانس :
                                                        {item?.is_renaissance ?
                                                            <CBadge color="success" className='m-1'>
                                                                تایید شده
                                                            </CBadge> :
                                                            <CBadge color="danger" className='m-1'>
                                                                تایید نشده
                                                            </CBadge>
                                                        }
                                                        |
                                                        تعداد تراکنشات :
                                                        <CBadge color="info" className='m-1'>
                                                            {item?.txns}
                                                        </CBadge>
                                                        <div className="mt-2"/>


                                                        <CRow className="row justify-content-md-center">
                                                            <CCol sm="auto">
                                                                <Analysis data={item}/>
                                                            </CCol>
                                                            <CCol sm="auto">
                                                                <Holder data={item}/>
                                                            </CCol>
                                                            <CCol sm="auto">
                                                                <br/>
                                                                <CButton color="light" className="position-relative"
                                                                         onClick={() => (handelSelecetItem(item.id))}>
                                                                    انتخاب
                                                                </CButton>
                                                            </CCol>
                                                        </CRow>
                                                    </small>
                                                </CCardFooter>
                                            </CCard>
                                        </CCol>
                                    ))}
                                    {dashboard.key === 'earthquake' &&
                                        <CTable>
                                            <CTableHead>
                                                <CTableRow>
                                                    <CTableHeaderCell scope="col">نام</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">قیمت</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">تغیرات 5 دقیقه</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">تغیرات 24 ساعت</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">تعداد تراکنشات</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">تعداد هولدر ها</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col">رینانس</CTableHeaderCell>
                                                </CTableRow>
                                            </CTableHead>
                                            <CTableBody>
                                                {data?.map((item) => (
                                                        <CTableRow color={selectedItems.find((e) => {
                                                            return e === item.id
                                                        }) && "danger"}>
                                                            <CTableDataCell scope="row">{item.name}</CTableDataCell>
                                                            <CTableDataCell>{item.price}</CTableDataCell>
                                                            <CTableDataCell>{item.percent_changes_5m}</CTableDataCell>
                                                            <CTableDataCell>{item.percent_changes_24h}</CTableDataCell>
                                                            <CTableDataCell>{item.txns}</CTableDataCell>
                                                            <CTableDataCell>{item.holdersCount}</CTableDataCell>
                                                            <CTableDataCell>
                                                                {item?.is_renaissance ?
                                                                    <CBadge color="success" className='m-1'>
                                                                        تایید شده
                                                                    </CBadge> :
                                                                    <CBadge color="danger" className='m-1'>
                                                                        تایید نشده
                                                                    </CBadge>
                                                                }
                                                                <CBadge color="danger" className='m-1'
                                                                        onClick={() => (handelSelecetItem(item.id))}>
                                                                    انتخاب
                                                                </CBadge>
                                                            </CTableDataCell>
                                                        </CTableRow>
                                                    )
                                                )
                                                }

                                            </CTableBody>
                                        </CTable>
                                    }
                                </CRow>

                            </CCardBody>
                            {data.length < count &&
                                <div className="d-grid gap-2 col-6 mx-auto mb-5">
                                    <CButton color="primary" onClick={() => (fetchData(data, count, page, ""))}>نمایش
                                        بیشتر</CButton>
                                </div>
                            }
                        </CCard>
                    </CRow>
                </CContainer>
            )}
        </>

    );
}

export default Dashboard;